// extracted by mini-css-extract-plugin
export default {"nameInputContainer":"Oex8fKK5pgJ3I9iNp7yn","inputWrapper":"lMfftM43j9moDMrUWfb8"};